export default function FormErrors (props) {
  if (!props.errors || !props.errors.length) return null;

  const errors = props.errors.filter(error =>
    props.param ? error.param === props.param : error.param == null
  );

  if (!errors.length) return null;
  

  return (
    <ul style={{
      color: '#ff8899',
      fontSize: '0.85rem',
      margin: '0px 0 8px 0',
      paddingLeft: '16px',
      lineHeight: 1.3,
    }}>
      {errors.map((e, i) => <li key={i}>{e.message}</li>)}
    </ul>
  );
}
